export function buildScenariosPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.ScenariosPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}
export function buildSettingsPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string | null)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.SettingsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'ScenarioId': scenarioId
	}
}

export function buildPortfoliosPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.PortfoliosPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'ScenarioId': scenarioId
	}
}

export function buildSchedulingSettingsQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.SchedulingSettingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'ScenarioId': scenarioId
	}
}




export function buildProjectsPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.ProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'ScenarioId': scenarioId
	}
}

export function buildSchedulingPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.SchedulingPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'ScenarioId': scenarioId
	}
}

export function buildPnlPageQueryV1(workspaceId: number, strategyId: string, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.PnlPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'ScenarioId': scenarioId
	}
}


export function buildCorporateScenarioPnlQueryV1(workspaceId: number, strategyId: string, scenarioId: string, applyBenefitsConfidenceFactor: boolean, pnlTemplateId: string, denomination: string)
{
	return {
		'$type': 'TCh.Domain.Quest.CorporateScenarios.Queries.CorporateScenarioPnlQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
		'ScenarioId': scenarioId,
		'ApplyBenefitsConfidenceFactor': applyBenefitsConfidenceFactor,
		'PnlTemplateId': pnlTemplateId,
		'Denomination': denomination
	}
}

